import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { ConnectionStatusUpdate } from '@/api/signalR/worker/messages/WorkerSentMessage.ts';
import type { StreamingState } from '@/store/streaming/state';

const initialState: StreamingState = {
  connectionStatus: { status: 'idle' },
};

export const streamingSlice = createSlice({
  name: 'streaming',
  reducerPath: 'streaming',

  initialState: initialState,

  reducers: {
    signalRStatusUpdated: (state, { payload: connectionStatus }: PayloadAction<ConnectionStatusUpdate>) => {
      state.connectionStatus = connectionStatus;
    },
  },

  selectors: {
    getSignalRConnectionId: (state) => {
      const connectionStatus = state.connectionStatus;
      return connectionStatus.status === 'connected' ? connectionStatus.connectionId : undefined;
    },

    getIsStreamingConnected: (state) => state.connectionStatus.status === 'connected',

    getIsStreamingUnusable: (state) =>
      state.connectionStatus.status !== 'connected' || state.connectionStatus.isDegraded,

    getStreamingConnectionStatus: (state) => state.connectionStatus,
  },
});

export const { signalRStatusUpdated } = streamingSlice.actions;

export const { getSignalRConnectionId, getIsStreamingConnected, getIsStreamingUnusable, getStreamingConnectionStatus } =
  streamingSlice.selectors;
